import React from 'react';
import { TextInput, StyleSheet, Platform, TextStyle, ViewStyle, StyleProp } from 'react-native';
import { COLORS, APP_CONSTANTS } from '@/constants/residents';

type Props = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  inputRef?: React.RefObject<TextInput | null>;
  style?: StyleProp<TextStyle | ViewStyle>;
  editable?: boolean;
  onSubmitEditing?: () => void;
};

export const EmailInput: React.FC<Props> = ({
  value,
  onChangeText,
  placeholder = 'Email',
  autoFocus,
  inputRef,
  style,
  editable = true,
  onSubmitEditing,
}) => {
  return (
    <TextInput
      ref={inputRef}
      style={[styles.input, style as any]}
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor={COLORS.TEXT_SECONDARY}
      keyboardType="email-address"
      autoCapitalize="none"
      autoCorrect={false}
      textContentType={Platform.select({ ios: 'username', default: 'emailAddress' }) as any}
      autoComplete="email"
      autoFocus={autoFocus}
      editable={editable}
      onSubmitEditing={onSubmitEditing}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    height: APP_CONSTANTS.TEXT_FIELD_HEIGHT,
    borderWidth: 1,
    borderColor: COLORS.SECONDARY,
    borderRadius: APP_CONSTANTS.BUTTON_CORNER_RADIUS,
    paddingHorizontal: 16,
    fontSize: APP_CONSTANTS.INPUT_FONT_SIZE,
    color: COLORS.TEXT_PRIMARY,
    backgroundColor: COLORS.SECONDARY,
    fontFamily: Platform.select({
      ios: 'Avenir-Book',
      android: 'sans-serif',
      default: 'System',
    }),
    ...Platform.select({
      web: {
        outlineStyle: 'none' as any,
      },
    }),
  },
});


